var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 10.9046C0.46875 4.88216 5.35063 3.24249e-05 11.3737 3.24249e-05C17.3954 3.24249e-05 22.2773 4.88216 22.2773 10.9046C22.2773 16.9269 17.3954 21.809 11.3737 21.809C5.35063 21.809 0.46875 16.9269 0.46875 10.9046Z",
    fill: "#A3CF6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16035 8.87557C8.16035 9.62346 7.79958 10.2299 7.35566 10.2299C6.91301 10.2299 6.55225 9.62346 6.55225 8.87557C6.55225 8.12768 6.91301 7.52116 7.35566 7.52116C7.79958 7.52116 8.16035 8.12768 8.16035 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1942 8.87557C16.1942 9.62346 15.8347 10.2299 15.3908 10.2299C14.9469 10.2299 14.5874 9.62346 14.5874 8.87557C14.5874 8.12768 14.9469 7.52116 15.3908 7.52116C15.8347 7.52116 16.1942 8.12768 16.1942 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9688 13.375C14.4688 17.5002 7.96875 17.5003 7.46875 13.3751L14.9688 13.375Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized8);
export default __webpack_public_path__ + "static/media/sylized_8.2d52360c25131553f74cd3ddd2c37bc4.svg";
export { ForwardRef as ReactComponent };